'use strict';
/* DRP Media — Editor Templates v1 */
window.EDITOR_TEMPLATES = [
  {
    id: 'team-jersey',
    name: 'Team Jersey',
    category: 'Sports',
    front: {
      elements: [
        { type:'text', content:'TEAM NAME', font:'Impact', size:44, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.28, scale:1 },
        { type:'text', content:'{{NUMBER}}', font:'Impact', size:72, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.52, scale:1 },
      ]
    },
    back: {
      elements: [
        { type:'text', content:'{{NAME}}', font:'Impact', size:34, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.22, scale:1 },
        { type:'text', content:'{{NUMBER}}', font:'Impact', size:68, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.48, scale:1 },
      ]
    }
  },
  {
    id: 'business-logo',
    name: 'Business Logo',
    category: 'Corporate',
    front: {
      elements: [
        { type:'text', content:'YOUR COMPANY', font:'Montserrat', size:36, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.35, scale:1 },
        { type:'text', content:'EST. 2024', font:'Space Grotesk', size:16, bold:false, color:'#CCCCCC', align:'center', x:0.5, y:0.46, scale:1 },
      ]
    },
    back: { elements: [] }
  },
  {
    id: 'event-shirt',
    name: 'Event Shirt',
    category: 'Events',
    front: {
      elements: [
        { type:'text', content:'EVENT NAME', font:'Bebas Neue', size:48, bold:false, color:'#E8F60E', align:'center', x:0.5, y:0.30, scale:1 },
        { type:'text', content:'2026', font:'Space Grotesk', size:22, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.42, scale:1 },
      ]
    },
    back: {
      elements: [
        { type:'text', content:'SPONSORS', font:'Space Grotesk', size:22, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.20, scale:1 },
      ]
    }
  },
  {
    id: 'gym-fitness',
    name: 'Gym / Fitness',
    category: 'Sports',
    front: {
      elements: [
        { type:'text', content:'NO DAYS OFF', font:'Bebas Neue', size:52, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.38, scale:1 },
      ]
    },
    back: { elements: [] }
  },
  {
    id: 'music-band',
    name: 'Music Band',
    category: 'Casual',
    front: {
      elements: [
        { type:'text', content:'BAND NAME', font:'Permanent Marker', size:44, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.30, scale:1 },
        { type:'text', content:'WORLD TOUR 2026', font:'Space Grotesk', size:14, bold:false, color:'#AAAAAA', align:'center', x:0.5, y:0.42, scale:1 },
      ]
    },
    back: {
      elements: [
        { type:'text', content:'CITY DATES HERE', font:'Space Grotesk', size:14, bold:false, color:'#CCCCCC', align:'center', x:0.5, y:0.28, scale:1 },
      ]
    }
  },
  {
    id: 'family-reunion',
    name: 'Family Reunion',
    category: 'Events',
    front: {
      elements: [
        { type:'text', content:'THE SMITH FAMILY', font:'Lobster', size:38, bold:false, color:'#E8F60E', align:'center', x:0.5, y:0.30, scale:1 },
        { type:'text', content:'REUNION 2026', font:'Space Grotesk', size:18, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.42, scale:1 },
      ]
    },
    back: { elements: [] }
  },
  {
    id: 'school-spirit',
    name: 'School Spirit',
    category: 'Sports',
    front: {
      elements: [
        { type:'text', content:'SCHOOL NAME', font:'Impact', size:42, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.28, scale:1 },
        { type:'text', content:'CLASS OF \'26', font:'Space Grotesk', size:22, bold:true, color:'#E8F60E', align:'center', x:0.5, y:0.44, scale:1 },
      ]
    },
    back: { elements: [] }
  },
  {
    id: 'restaurant-staff',
    name: 'Staff Uniform',
    category: 'Corporate',
    front: {
      elements: [
        { type:'text', content:'RESTAURANT NAME', font:'Montserrat', size:28, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.32, scale:1 },
        { type:'text', content:'STAFF', font:'Space Grotesk', size:16, bold:false, color:'#AAAAAA', align:'center', x:0.5, y:0.44, scale:1 },
      ]
    },
    back: { elements: [] }
  },
  {
    id: 'charity-run',
    name: 'Charity Run',
    category: 'Events',
    front: {
      elements: [
        { type:'text', content:'RUN FOR A CAUSE', font:'Bebas Neue', size:46, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.28, scale:1 },
        { type:'text', content:'5K · 2026', font:'Space Grotesk', size:18, bold:false, color:'#E8F60E', align:'center', x:0.5, y:0.42, scale:1 },
      ]
    },
    back: {
      elements: [
        { type:'text', content:'{{NAME}}', font:'Space Grotesk', size:22, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.20, scale:1 },
        { type:'text', content:'{{NUMBER}}', font:'Space Grotesk', size:16, bold:false, color:'#AAAAAA', align:'center', x:0.5, y:0.30, scale:1 },
      ]
    }
  },
  {
    id: 'minimalist-logo',
    name: 'Minimalist Logo',
    category: 'Casual',
    front: {
      elements: [
        { type:'text', content:'YOUR BRAND', font:'Oswald', size:30, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.38, scale:1 },
      ]
    },
    back: { elements: [] }
  },
  {
    id: 'streetwear',
    name: 'Streetwear',
    category: 'Casual',
    front: {
      elements: [
        { type:'text', content:'DROP MEDIA', font:'Bebas Neue', size:54, bold:false, color:'#FFFFFF', align:'center', x:0.5, y:0.35, scale:1 },
      ]
    },
    back: {
      elements: [
        { type:'text', content:'EST. MMXXIV', font:'Space Grotesk', size:12, bold:false, color:'#666666', align:'center', x:0.5, y:0.85, scale:1 },
      ]
    }
  },
  {
    id: 'bachelor',
    name: 'Bachelor Party',
    category: 'Events',
    front: {
      elements: [
        { type:'text', content:'LAST RIDE', font:'Permanent Marker', size:44, bold:false, color:'#E8F60E', align:'center', x:0.5, y:0.28, scale:1 },
        { type:'text', content:'{{NAME}}\'S CREW', font:'Space Grotesk', size:18, bold:true, color:'#FFFFFF', align:'center', x:0.5, y:0.44, scale:1 },
      ]
    },
    back: { elements: [] }
  },
];
